module.exports = __webpack_public_path__ + "static/media/12.3ecab86b.jpg";